import React from "react";

import CheckIcon from "images/icons/checkmark-icon.inline.svg";

const ApplicationProgressBar = ({ currentStep, isEnquiry = false }) => {
  return (
    <div className="w-full h-32 my-5 flex justify-center md:justify-normal md:flex-col md:w-2/3">
      <div className="flex flex-col justify-center items-center py-4">
        <div className="w-4/5 md:w-3/5 flex justify-between">
          <div className="flex flex-col items-center gap-2 w-1/5 z-10">
            <div className="w-10 h-10 flex justify-center items-center">
              {currentStep === 0 ? (
                <div className="planet:bg-gray-darker planet:border-green-standard border-1 rounded-full overflow-hidden">
                  <div className="h-6 w-6 flex justify-center items-center">
                    <div className="h-2 w-2 planet:bg-green-standard rounded-full border-0 border-white"></div>
                  </div>
                </div>
              ) : (
                <div className="bg-yellow-lighten border-yellow-lighten planet:bg-green-standard planet:border-gray-darker border-0.5 rounded-full overflow-hidden h-6 w-6 flex justify-center items-center">
                  <CheckIcon className="h-2.5 w-2.5 stroke-gray-darker" />
                </div>
              )}
            </div>

            <div
              className="w-full flex justify-center items-center text-yellow-lighten planet:text-green-standard text-center font-bold text-sm"
              dangerouslySetInnerHTML={{
                __html: isEnquiry
                  ? "Submit your enquiry"
                  : "Submit your application"
              }}
            />
          </div>
          <div className="w-1/5 spacer relative">
            <div className="w-full h-10 relative before:-left-1/2 before:absolute before:-right-1/2 before:top-1/2 before:h-[1px] before:bg-yellow-lighten planet:before:bg-green-standard"></div>
          </div>
          <div className="flex flex-col items-center gap-2 w-1/5 z-10 ">
            <div className="w-10 h-10 flex justify-center items-center">
              {currentStep === 1 ? (
                <div className="bg-black-quinary border-yellow-lighten planet:bg-gray-dark planet:border-green-standard border-1 rounded-full overflow-hidden">
                  <div className="h-6 w-6 flex justify-center items-center">
                    <div className="h-2 w-2 bg-yellow-lighten border-yellow-lighten planet:bg-green-standard rounded-full border-1 planet:border-green-standard"></div>
                  </div>
                </div>
              ) : currentStep < 1 ? (
                <div className="planet:bg-transparent planet:border-gray-lightdecimal border-1 rounded-full overflow-hidden">
                  <div className="h-6 w-6 flex justify-center items-center">
                    <div className="h-2 w-2 planet:bg-transparent rounded-full border-0"></div>
                  </div>
                </div>
              ) : (
                <div className="bg-yellow-lighten border-yellow-lighten planet:bg-green-standard planet:border-gray-darker border-0.5 rounded-full overflow-hidden h-6 w-6 flex justify-center items-center">
                  <CheckIcon className="h-2.5 w-2.5 stroke-gray-darker" />
                </div>
              )}
            </div>

            <div
              className={`w-full flex justify-center items-center ${currentStep >= 1 ? "text-yellow-lighten planet:text-green-standard" : "text-white planet:text-gray-lightdecimal"} text-center font-bold text-sm`}
              dangerouslySetInnerHTML={{
                __html: "Choose your preferences"
              }}
            />
          </div>
          <div className="w-1/5 spacer relative">
            <div
              className={`w-full h-10 relative before:-left-1/2 before:absolute before:-right-1/2 before:top-1/2 before:h-[1px]  ${currentStep >= 8 ? "before:bg-yellow-lighten planet:before:bg-green-standard" : "before:bg-white planet:before:bg-gray-lightdecimal"}`}
            />
          </div>
          <div className="w-1/5 flex flex-col items-center gap-2 z-10">
            <div className="w-10 h-10 flex justify-center items-center">
              {currentStep === 8 ? (
                <div className="bg-black-quinary border-yellow-lighten planet:bg-gray-dark planet:border-green-standard border-1 rounded-full overflow-hidden">
                  <div className="h-6 w-6 flex justify-center items-center">
                    <div className="h-2 w-2 bg-yellow-lighten planet:bg-green-standard rounded-full border-0 border-yellow-lighten planet:border-green-standard"></div>
                  </div>
                </div>
              ) : currentStep < 8 ? (
                <div className="bg-black-quinary border-white planet:bg-gray-dark planet:border-gray-lightdecimal border-1 rounded-full overflow-hidden">
                  <div className="h-6 w-6 flex justify-center items-center">
                    <div className="h-2 w-2 planet:bg-transparent rounded-full border-0"></div>
                  </div>
                </div>
              ) : (
                <div className="bg-white border-white planet:bg-green-standard planet:border-gray-darker border-0.5 rounded-full overflow-hidden h-6 w-6 flex justify-center items-center">
                  <CheckIcon className="h-2.5 w-2.5 stroke-gray-darker" />
                </div>
              )}
            </div>

            <div
              className={`w-full flex flex-1 justify-center items-center text-center font-bold text-sm ${currentStep >= 8 ? "planet:text-green-standard text-yellow-lighten" : "planet:text-gray-lightdecimal text-white"}`}
              dangerouslySetInnerHTML={{
                __html: "Talk to us"
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApplicationProgressBar;
